import {COLUMN_TYPES} from 'src/components/with-interaction-table/constants';

import {TDataType as DataType} from '@pb/kit-component-table-interactions';

import type {InteractiveColumn} from 'src/components/with-interaction-table/typedef';

export const EXISTED_USER_MESSAGE = 'Existing user associated with this email found on the platform. ' +
    'This user will be transferred to the new account assigned here.';
export const INVALID_EMAIL_MESSAGE = 'Email address is not valid';
export const INVALID_FIRST_NAME_MESSAGE = 'First name is not valid';
export const INVALID_LAST_NAME_MESSAGE = 'Last name is not valid';
export const INVALID_CITY_MESSAGE = 'City is too long.';
export const INVALID_JOB_TITLE_MESSAGE = 'Job title is too long';

export const SELECTION_KEY = 'bulk-import-selection';

export const COLUMNS = {
    EMAIL: 'email',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    USER_TYPE: 'userType',
    USER_STATUS: 'userStatus',
    COUNTRY: 'country',
    TARGET_ACCOUNT: 'targetAccount',
    PRIOR_ACCOUNT: 'priorAccount',
    GROUP: 'group',
    JOB_TITLE: 'jobTitle',
    CITY: 'city',
    NEWSLETTERS: 'newsletters',
    NOTES: 'notes',
};

export const HEADERS = {
    [COLUMNS.EMAIL]: 'Email*',
    [COLUMNS.FIRST_NAME]: 'First Name*',
    [COLUMNS.LAST_NAME]: 'Last Name*',
    [COLUMNS.USER_TYPE]: 'Type*',
    [COLUMNS.USER_STATUS]: 'Status*',
    [COLUMNS.TARGET_ACCOUNT]: 'Target Account*',
    [COLUMNS.PRIOR_ACCOUNT]: 'Prior Account',
    [COLUMNS.COUNTRY]: 'Country',
    [COLUMNS.GROUP]: 'Group',
    [COLUMNS.JOB_TITLE]: 'Job Title',
    [COLUMNS.CITY]: 'City',
    [COLUMNS.NEWSLETTERS]: 'Newsletters',
    [COLUMNS.NOTES]: 'Notes',
};

export const COLUMNS_DATA: Array<InteractiveColumn> = [
    {
        columnId: COLUMNS.EMAIL,
        fixed: true,
        defaultWidth: 400,
        minWidth: 400,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.FIRST_NAME,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.LAST_NAME,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.USER_TYPE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.USER_STATUS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.TARGET_ACCOUNT,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.PRIOR_ACCOUNT,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.COUNTRY,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.GROUP,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.JOB_TITLE,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.CITY,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
    {
        columnId: COLUMNS.NEWSLETTERS,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.STATIC,
    },
    {
        columnId: COLUMNS.NOTES,
        fixed: false,
        defaultWidth: 200,
        minWidth: 200,
        maxWidth: 520,
        dataType: DataType.TEXT,
        columnType: COLUMN_TYPES.STRING,
    },
];

export const TRACKING_COLUMNS = [
    'Email',
    'First name',
    'Last name',
    'User type',
    'User status',
    'Target account',
    'Prior account',
    'Country',
    'Group',
    'Job title',
    'City',
    'Newsletters',
    'Notes',
];
